import { Textarea } from '@nextui-org/react'
import CreateDropZone from './CreateDropZone'

export default function CompanyTenderExperience({ formData, handleChange, userUUID, isForUser }: any) {
  return (
    <div className="flex flex-col gap-4">
      <Textarea
        label="Previous Tender Participation"
        labelPlacement="outside"
        variant="bordered"
        placeholder="Detail quantity, nature, and outcomes of prior tenders or large RFPs, plus lessons learnt. Demonstrated procurement literacy reduces perceived execution risk."
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        onChange={(e) => handleChange?.('previousTenderParticipation', e.target.value)}
        value={formData?.previousTenderParticipation}
      />
      <Textarea
        label="Notable Contracts Won"
        labelPlacement="outside"
        variant="bordered"
        placeholder="Highlight high-profile or high-value contracts already secured through competition—proof of capability to win and deliver under formal procurement."
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        onChange={(e) => handleChange?.('notableContractsWon', e.target.value)}
        value={formData?.notableContractsWon}
      />
      <Textarea
        isRequired
        label="Experience with Tender Platforms"
        placeholder="Specify accounts on DTVP, cosinex, subreport, ANKÖ, simap.ch, TED, etc. Existing registrations streamline submissions and avoid last-minute platform onboarding delays"
        variant="bordered"
        labelPlacement="outside"
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        onChange={(e) => handleChange?.('experienceWithTendersPlatform', e.target.value)}
        value={formData?.experienceWithTendersPlatform}
      />
      <div className="flex flex-row gap-4">
        <div className="flex flex-1">
          <Textarea
            label="Prequalification Certificates"
            labelPlacement="outside"
            variant="bordered"
            placeholder="Provide any permanent qualification attestations (e.g., Präqualifikation) that replace repetitive proof obligations and can instantly satisfy administrative criteria"
            classNames={{
              inputWrapper: 'flex flex-1',
            }}
            onChange={(e) => handleChange?.('prequalificationText', e.target.value)}
            value={formData?.prequalificationText}
          />
        </div>
        <div className="flex flex-1">
          <CreateDropZone
            title={'Certificates'}
            description="."
            onFilesChange={(files) => handleChange?.('prequalificationFile', files)}
            userUUID={userUUID}
            isForUser={isForUser}
            files={formData?.prequalificationFile ?? []} 
          />
        </div>
      </div>
      <Textarea
        isRequired
        label="Joint Venture / Consortium Experience"
        placeholder="Summarise any previous consortium arrangements, governance models, and contact references—valuable when contemplating teaming strategies for multi-lot megatenders."
        variant="bordered"
        labelPlacement="outside"
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        onChange={(e) => handleChange?.('jointVenture', e.target.value)}
        value={formData?.jointVenture}
      />

      <Textarea
        isRequired
        label="Knowledge of Public Procurement Rules"
        placeholder="Indicate whether you have certified procurement specialists or trained staff; this can ease internal compliance alignment during project execution."
        variant="bordered"
        labelPlacement="outside"
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        onChange={(e) => handleChange?.('knowledgePublicProcurmentRules', e.target.value)}
        value={formData?.knowledgePublicProcurmentRules}
      />
    </div>
  )
}
